/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect, useContext } from "react";
import PropTypes from "prop-types";
import { withRouter, useParams, useHistory } from "react-router-dom";
import Page from "components/common_components/Page/Page";
import { useDispatch } from "react-redux";
import { notifyError, notifySuccess } from "redux/actions/Notifications";
import LoadingPage from "components/common_components/LoadingPage";
import Form from "./Form";
import SigninSheetContext from "./SigninSheetContext";
import Header from "components/common_components/Header";
import AppContext from "AppContext";
import { Grid } from "@material-ui/core";

function SigninSheetEntry(props) {
    const history = useHistory();
    const { id } = useParams();
    const [signinSheet, setSigninSheet] = useState(undefined);
    const [resources, setResources] = useState(undefined);
    const [isLoading, setIsLoading] = useState(false);
    const dispatch = useDispatch();
    const { mode } = props;

    const SigninSheet = useContext(SigninSheetContext);
    const {
        api: {
            Settings: { Users },
            Management: { Visitors },
            Modules,
        },
        allowedModules,
    } = useContext(AppContext);

    function getSigninSheet() {
        setIsLoading(true);
        SigninSheet.getOneById({
            id,
            onSuccess: (data) => {
                setSigninSheet(data);
                setIsLoading(false);
            },
            onError: (error) => {
                dispatch(notifyError(error));
                setIsLoading(false);
            },
        });
    }

    function getResources() {
        Users.getAll({
            onSuccess: (data) => {
                setResources({ users: data });
            },
            onError: (error) => {
                setResources({ users: [] });
                dispatch(notifyError(error));
            },
        });
    }

    useEffect(() => {
        if (id) {
            getSigninSheet();
        }
    }, [id]);

    useEffect(() => {
        getResources();
    }, []);

    function onEditHandler() {
        history.push(`/check-in/${id}/update`);
    }

    function onCancelHandler() {
        history.goBack();
    }

    function onSuccess(_, setSubmitting) {
        setSubmitting(false);
        dispatch(notifySuccess(`Check-in ${mode === "add" ? "created" : "updated"} successfully!`));
        history.push("/check-in");
    }

    function onError(error, setSubmitting, setErrors) {
        if (error && error.errors) {
            setErrors(error.errors);
            dispatch(notifyError(error.message));
        } else {
            onCancelHandler();
            dispatch(notifyError(error));
        }
        setSubmitting(false);
    }

    async function onSubmitHandler(values, { setSubmitting, setErrors }) {
        const { firstName, middleName, lastName, assignee, appointmentTime, isFirstTime, caseFileNo, reasonForVisit, visitorId } = values;

        const apiCall = mode === "add" ? SigninSheet.add : SigninSheet.update;

        apiCall({
            payload: {
                id: mode === "update" ? id : null,
                firstName,
                middleName,
                lastName,
                isFirstTime,
                assigneeUserId: assignee ? assignee.id : null,
                caseFileNo: caseFileNo ? caseFileNo.toUpperCase() : null,
                appointmentTime: appointmentTime instanceof Date ? appointmentTime.toISOString() : null,
                reasonForVisit,
                visitorId: visitorId ? visitorId : null,
            },
            onSuccess: (response) => onSuccess(response, setSubmitting),
            onError: (error) => onError(error, setSubmitting, setErrors),
        });
    }

    return (
        <Page className="check-in-page">
            <Grid container spacing={3} justifyContent="center">
                <Grid item sm={12} md={12} lg={10}>
                    <Header title="Check-in" />
                </Grid>
            </Grid>

            {isLoading && <LoadingPage />}
            {!isLoading && (
                <Form
                    signinSheet={signinSheet}
                    resources={resources}
                    {...props}
                    onCancel={onCancelHandler}
                    onSubmit={onSubmitHandler}
                    onEdit={onEditHandler}
                    modulesApi={Modules}
                    allowedModules={allowedModules}
                    visitorsApi={Visitors}
                />
            )}
        </Page>
    );
}

SigninSheetEntry.propTypes = {
    mode: PropTypes.oneOf(["add", "detail", "update"]).isRequired,
    title: PropTypes.string,
};

export default withRouter(SigninSheetEntry);
